
export const sendNotification = async (title: string, options?: NotificationOptions) => {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    console.warn("Notifications not supported");
    return;
  }

  if (Notification.permission !== 'granted') {
    return;
  }

  try {
    // Prioritize Service Worker for Mobile/PWA support (avoids "Illegal constructor" error)
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration && registration.active) {
        await registration.showNotification(title, options);
        return;
      }
    }
    
    // Fallback for Desktop or if no SW active
    new Notification(title, options);
  } catch (e) {
    console.error("Notification failed:", e);
    
    // Last resort fallback
    try {
      if (e instanceof TypeError && e.message.includes("Illegal constructor")) {
         console.warn("Skipping Notification: SW required but not found.");
      } else {
         new Notification(title, options);
      }
    } catch (e2) {
      // Ignore
    }
  }
};
